import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Organization } from 'src/app/component/common-components/organizations/model/organization.model';
import { OrganizationService } from 'src/app/component/common-components/organizations/service/organization.service';
import { ObjectToArrayPipe } from './object-to-array.pipe'; // Adjust the path as necessary
import { ViewGradeIntersectBtnComponent } from './view-grade-intersect-btn/view-grade-intersect-btn.component'; 

interface GradeTotal {
  [key: string]: any; // You can replace `any` with the actual type if you know it
}


@Component({
  selector: 'view-grade-alignmt-table',
  templateUrl: './view-grade-alignmt-table.component.html',
  styleUrls: ['./view-grade-alignmt-table.component.scss']
})
export class ViewGradeAlignmtTableComponent implements OnInit {

  @ViewChild("ViewGradeIntersectBtnComponent") appViewGradeIntersectBtnComponent!: ViewGradeIntersectBtnComponent;
  @Input() schoolYear: any;

  gradeTotal: GradeTotal = { /* Your gradeTotal object */ };

  columns: any = {
    'Region': { ENABLED: true, SORT: 'SCHOOL.REGIONS.CODE', DISABLED: true },
    'School Year': { ENABLED: true, SORT: 'SCHOOL_ENROLLMENT_DETAILS[0].SCHOOL_YEAR', DISABLED: true },
    'District': { ENABLED: true, SORT: 'SCHOOL.SCHOOL_DISTRICT.DISTRICTS', DISABLED: true },
    'School': { ENABLED: true, SORT: 'SCHOOL.NAME', DISABLED: true },
    'School CDS Code': { ENABLED: true, SORT: 'SCHOOL.cdscODE', DISABLED: true },

    'MSD Number': { ENABLED: true, SORT: 'MSD_NUMBER', DISABLED: true },

    'Name': { ENABLED: true, SORT: 'PERSON.LAST_NAME', DISABLED: true },

    'Grade': { ENABLED: true, SORT: 'SCHOOL_ENROLLMENT_DETAILS[0].GRADE', DISABLED: true },
    'SSID': { ENABLED: true, SORT: 'SSID', DISABLED: true },
  }

  gradeOptions: any = [
    { INDEX: 1, GRADES: 'P0', selectable: true },
    { INDEX: 2, GRADES: 'P1', selectable: true },
    { INDEX: 3, GRADES: 'P2', selectable: true },
    { INDEX: 4, GRADES: 'P3', selectable: true },
    { INDEX: 5, GRADES: 'P4', selectable: true },
    { INDEX: 6, GRADES: 'P5', selectable: true },
    { INDEX: 7, GRADES: 'P6', selectable: true },
    { INDEX: 8, GRADES: 'PK', selectable: true, requires: ['R'] },
    { INDEX: 9, GRADES: 'K', selectable: true, requires: ['R'] },
    { INDEX: 10, GRADES: '01', selectable: true, requires: ['R'] },
    { INDEX: 11, GRADES: '02', selectable: true, requires: ['R'] },
    { INDEX: 12, GRADES: '03', selectable: true, requires: ['R'] },
    { INDEX: 13, GRADES: '04', selectable: true, requires: ['R'] },
    { INDEX: 14, GRADES: '05', selectable: true, requires: ['R'] },
    { INDEX: 15, GRADES: '06', selectable: true, requires: ['R'] },
    { INDEX: 16, GRADES: '07', selectable: true, requires: ['R'] },
    { INDEX: 17, GRADES: '08', selectable: true, requires: ['R'] },
    { INDEX: 18, GRADES: '09', selectable: true, requires: ['R'] },
    { INDEX: 19, GRADES: '10', selectable: true, requires: ['R'] },
    { INDEX: 20, GRADES: '11', selectable: true, requires: ['R'] },
    { INDEX: 21, GRADES: '12', selectable: true, requires: ['R'] },
    { INDEX: 22, GRADES: 'AD', selectable: true, requires: ['R'] },
    { INDEX: 23, GRADES: 'UG', selectable: true, requires: ['R'], static: true },
    { INDEX: 24, GRADES: 'NA', selectable: true, requires: ['N'], static: true },
    { INDEX: 25, GRADES: 'Invalid (Other)', selectable: false, static: true },
    { INDEX: 26, GRADES: 'Total For Age', selectable: false, static: true }
  ];

  ageOptions: any = [
    { AGE: '0' },
    { AGE: '1' },
    { AGE: '2' },
    { AGE: '3' },
    { AGE: '4' },
    { AGE: '5' },
    { AGE: '6' },
    { AGE: '7' },
    { AGE: '8' },
    { AGE: '9' },
    { AGE: '10' },
    { AGE: '11' },
    { AGE: '12' },
    { AGE: '13' },
    { AGE: '14' },
    { AGE: '15' },
    { AGE: '16' },
    { AGE: '17' },
    { AGE: '18' },
    { AGE: '19' },
    { AGE: '20' },
    { AGE: '21' },
    { AGE: '22' }
];

correctTableOptions: any = {
  '0': { 'P0': true, 'P1': true, 'UG': true },
  '1': { 'P0': true, 'P1': true, 'P2': true, 'UG': true },
  '2': { 'P1': true, 'P2': true, 'P3': true, 'UG': true },
  '3': { 'P2': true, 'P3': true, 'P4': true, 'UG': true },
  '4': { 'P3': true, 'P4': true, 'P5': true, 'PK': true, 'K': true, 'UG': true },
  '5': { 'P4': true, 'P5': true, 'P6': true, 'PK': true, 'K': true, '1': true, 'UG': true },
  '6': { 'P5': true, 'P6': true, 'K': true, '01': true, '02': true, 'UG': true, 'NA': true },
  '7': { 'P6': true, 'K': true, '01': true, '02': true, '03': true, 'UG': true, 'NA': true },
  '8': { '02': true, '03': true, '04': true, 'UG': true, 'NA': true },
  '9': { '03': true, '04': true, '05': true, 'UG': true, 'NA': true },
  '10': { '04': true, '05': true, '06': true, 'UG': true, 'NA': true },
  '11': { '05': true, '06': true, '07': true, 'UG': true, 'NA': true },
  '12': { '06': true, '07': true, '08': true, 'UG': true, 'NA': true },
  '13': { '07': true, '08': true, '09': true, 'UG': true, 'NA': true },
  '14': { '08': true, '09': true, '10': true, 'UG': true, 'NA': true },
  '15': { '09': true, '10': true, '11': true, 'UG': true, 'NA': true },
  '16': { '10': true, '11': true, '12': true, 'UG': true, 'NA': true },
  '17': { '11': true, '12': true, 'AD': true, 'UG': true, 'NA': true },
  '18': { '12': true, 'AD': true, 'UG': true, 'NA': true },
  '19': { 'AD': true, 'UG': true, 'NA': true },
  '20': { 'AD': true, 'UG': true, 'NA': true },
  '21': { 'UG': true, 'NA': true },
  '22': { 'AD': true, 'UG': true, 'NA': true }
};


slightlyOffTableOptions: any = {
  '0': {},
  '1': {},
  '2': {},
  '3': {},
  '4': {},
  '5': {},
  '6': { 'PK': true },
  '7': { 'PK': true, 'K': true },
  '8': { 'K': true, '01': true },
  '9': { '01': true, '02': true },
  '10': { '02': true, '03': true },
  '11': { '03': true, '04': true },
  '12': { '04': true, '05': true },
  '13': { '05': true, '06': true },
  '14': { '06': true, '07': true },
  '15': { '07': true, '08': true },
  '16': { '08': true, '09': true },
  '17': { '09': true, '10': true },
  '18': { '10': true, '11': true },
  '19': { '11': true, '12': true },
  '20': { '12': true },
  '21': { 'AD': true },
  '22': {}
};


  organizationService: OrganizationService;

  gradeObj: any;
  grade: any;
  showAll: boolean;
  table: any;
  objectToArray: ObjectToArrayPipe;


  constructor(organizationService: OrganizationService) { 

    console.log("calling constructor of view-grade-age-alignment-table")
    this.organizationService = organizationService;
  }

  ngOnInit(): void {
    let loadingPromises: any = [];
    let loading: boolean = true;

    this.getGradesTable();
  }

  getGradesTable() {
    console.log("view-grade-age-alignment-table.component calling getGradesTable()")  
    //let lstRegion: Region[] = [];
      this.organizationService.getGradesTable().subscribe((res) => {
           console.log(res)
          /*let grades = _.map(this.gradeOptions, function (grade: any) {
            return _.assign(grade, _.find(res.data.grades, { GRADES: grade.GRADES }));
          });*/
      });

  }

}
